import axios from "axios";

const publicClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000/api",
});

export default publicClient;
